import { NAME_CHANGED } from 'actiontypes/myself';
import { Dispatch } from 'redux';

export default function nameChanged(name: string) {
  return (dispatch: Dispatch) => dispatch({ type: NAME_CHANGED, payload: name });
}